export const SEARCH_PROFILE_REQUEST = 'app/ProfileInput/SEARCH_PROFILE_REQUEST';
export const SEARCH_PROFILE_SUCCESS = 'app/ProfileInput/SEARCH_PROFILE_SUCCESS';
export const SEARCH_PROFILE_ERROR = 'app/ProfileInput/SEARCH_PROFILE_ERROR';

export const RESET_STATE = 'app/ProfileInput/RESET_STATE';
